/* eslint-disable no-array-constructor */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Card,
  Col,
  Image,
  List,
  Modal,
  Row,
  Select,
  // Spin,
  Form,
  TimePicker,
  Upload,
  Divider,
  Popover,
  Steps,
} from "antd";
import { useState, useEffect, useRef } from "react";
import locale from "antd/es/date-picker/locale/de_DE";
import { Icon } from "@iconify/react";
import {
  useNavigate,
  // useLocation
} from "react-router-dom";
import * as moment from "moment";
import { Content } from "antd/lib/layout/layout";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import firebase from "firebase/app";
import "../payment/css/index.css";
import { apiServerUrl, imgDefaultUrl, serverUrl } from "../../constants";
import { useDimensions } from "../../common/mamager/ScreenManager";
import Header from "../../common/components/header";
import LoadingPage from "../../common/components/loading/page";
import Footer from "../../common/components/footer";
import { detectSignIn } from "../../common/mamager/DetectManager";
import { Notification } from "../../common/components/notification";
import { useDispatch, useSelector } from "react-redux";
import { setBasketOrderStateToSuccess } from "../../actions/basketOrder.action";
import { getPaymentAccountFetch, insertPaymentOrderFetch, lineNotifyPaymentOrder } from "./API";
import { v4 as uuidv4 } from "uuid";
import Video from "../../common/components/video";
// import { getUsageByIdFetch } from "../erp/manage/usage/API";

const { Option } = Select;

export default function Payment(props) {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const { resultBasketOrder } = useSelector(
    ({ basketOrderReducer }) => basketOrderReducer
  );

  const [paymentmethodLoading, setPaymentmethodLoading] = useState(false);

  const [imgTransferSlipURL, setImgTransferSlipURL] = useState({
    loading: false,
    imageUrl: null,
  });

  // const location = useLocation()
  // const params = new URLSearchParams(location.search)
  // const courseId = params.get("course-id")

  const [pamentTransferModal, setPamentTransferModal] = useState({
    isShow: false,
    title: null,
  });

  // const [course, setCourse] = useState(null)
  const [paymentAccount, setPaymentAccount] = useState(null);

  const dispatch = useDispatch();

  const [day, setDay] = useState([]);
  const [month, setMonth] = useState([]);
  const [year, setYear] = useState([]);

  const [uid, setUid] = useState(null);

  const [currentStep, setCurrentStep] = useState(0);

  //Remaing time for QR-code peyment
  const targetTime = new Date(new Date().getTime() + 15 * 60 * 1000); // 15 minutes in milliseconds
  // const targetTime = new Date(new Date().getTime());
  const [remainingTime, setRemainingTime] = useState(
    calculateRemainingTime(targetTime)
  );

  const optionTransferSlipImage = {
    name: "file",
    action: `${apiServerUrl}/upload/file`,
    data: {
      bucket: "witte-bangkok",
      folder: "payment/slip/image",
    },
    headers: {
      authorization: `Bearer ${firebase.auth().currentUser?.uid || ""}`,
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        if (info.fileList.length > 0 && info.file.response?.url) {
          setImgTransferSlipURL({
            imageUrl: info.file.response.url,
            loading: false,
          });
        } else {
          setImgTransferSlipURL({
            imageUrl: null,
            loading: false,
          });
        }
      } else {
        setImgTransferSlipURL({
          loading: true,
          imageUrl: imgTransferSlipURL.imageUrl,
        });
      }

      if (info.file.status === "done") {
        Notification(
          "success",
          "เเจ้งเตือน!",
          "อัพโหลดหลักฐานการชำระเงินสำเร็จ"
        );
      } else if (info.file.status === "error") {
        Notification(
          "error",
          "เเจ้งเตือน!",
          "ไม่สามารถอัพโหลดหลักฐานการชำระเงินได้ กรุณาลองใหม่อีกครั้ง"
        );
      }
    },
    progress: {
      strokeColor: {
        "0%": "#FF7F00",
        "100%": "#FF7F00",
      },
      strokeWidth: 3,
      width: "10%",
      format: (percent) => `${parseFloat(percent.toFixed(0))}%`,
    },
  };

  const { width } = useDimensions();

  const getCourseById = async () => {};

  const detectCourseHasBeenPurchased = async (uid) => {};

  const getDay = () => {
    let tmpDay = [];
    for (let i = 1; i <= 31; i++) {
      tmpDay.push({
        label: i,
        value: i,
      });
    }
    setDay(tmpDay);
  };

  const getMonth = () => {
    let tmpMonth = [
      { label: "มกราคม", value: 1 },
      { label: "กุมภาพันธ์", value: 2 },
      { label: "มีนาคม", value: 3 },
      { label: "เมษายน", value: 4 },
      { label: "พฤษภาคม", value: 5 },
      { label: "มิถุนายน", value: 6 },
      { label: "กรกฎาคม", value: 7 },
      { label: "สิงหาคม", value: 8 },
      { label: "กันยายน", value: 9 },
      { label: "ตุลาคม", value: 10 },
      { label: "พฤศจิกายน", value: 11 },
      { label: "ธันวาคม", value: 12 },
    ];
    setMonth(tmpMonth);
  };

  const getYear = () => {
    let tmpYear = [];
    let a = moment().format("YYYY");
    let yearCurrent = Number(a) + 543 - 1;
    for (let i = yearCurrent; i > yearCurrent - 100; i--) {
      tmpYear.push({
        label: i + 1,
        value: i + 1,
      });
    }
    setYear(tmpYear);
  };

  const detectProductCategory = (item) => {
    if (item.courseId && item.courseTypeId === 1) {
      // course
      return 1;
    }

    if (item.predictionId) {
      // prediction
      return 2;
    }

    if (item.courseId && item.courseTypeId === 2) {
      // exam certificate
      return 3;
    }

    return null;
  };

  const onFinish = async (values) => {
    let orderList = new Array();
    if (imgTransferSlipURL.imageUrl !== null) {
      let day = values.day;
      let month = values.month;
      let year = values.year;
      let date = Number(year) - 543 + "/" + month + "/" + day;
      let time = moment(String(values.time)).format("HH:mm");
      let dateTimeTransfer = moment(date + " " + time).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let paymentOrderGroupId = uuidv4();
      let orderType = null
      let orderNetPrice = "-"
      let orderName = "-"

      resultBasketOrder?.map((item, index) => {
        // set data for line notify
        orderName = item.title
        orderType = item.courseId ? 1 : (item.predictionId ? 2 : null)
        orderNetPrice = Intl.NumberFormat("en", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(item?.price) + " บาท"

        orderList.push({
          orderName: item.title,
          uid: props.user.uid,
          netPrice: item.price,
          paymentStatusId: 2,
          productCategoryId: detectProductCategory(item),
          transferSlipImageUrl: imgTransferSlipURL.imageUrl,
          dateTimeTransfer,
          isPaymentOrderParent: true, // default is true
          paymentOrderGroupId,
          courseId: item.courseId,
          predictionId: item.predictionId,
        });
      });

      const result = await insertPaymentOrderFetch(orderList); // must be array!
      if (result.isSuccess) {
        setCurrentStep(2);
        setFormDefault();
        dispatch(setBasketOrderStateToSuccess([]));
        Notification("success", "ส่งหลักฐานการชำระเงินสำเร็จ");

        // -----------------------------------------------------------------------

        let productType = "";
        switch (orderType) {
          case 1: productType = "คอร์สออนไลน์"; break;
          case 2: productType = "โหรออนไลน์"; break;
          default: productType = "-"; break;
        }
        
        let objLineNotify = {
          orderName,
          orderNetPrice,
          productType,	
          orderStatus: "รอการตรวจสอบชำระเงิน",
          orderDateTime: dateTimeTransfer,
          orderPaymentMethodType: "โอนเงิน",
        }
        await lineNotifyPaymentOrder(objLineNotify)

        // -----------------------------------------------------------------------
      } else {
        Notification(
          "error",
          "ไม่สามารถส่งหลักฐานการชำระเงินสำเร็จได้ กรุณาลองใหม่อีกครั้ง"
        );
      }
    } else {
      Notification("warning", "เเจ้งเตือน!", "กรุณาอัพโหลด หลักฐานการโอนเงิน");
    }
    window.scroll(0, 0);
  };

  const setFormDefault = (type) => {
    form.resetFields();

    // ser default image
    setPamentTransferModal({
      isShow: false,
      title: null,
    });
  };

  useEffect(() => {
    if (resultBasketOrder?.length <= 0) {
      navigate("/course");
    }
  }, []);

  function calculateRemainingTime(targetTime) {
    const now = new Date();
    const timeDiff = targetTime - now;

    if (timeDiff <= 0) return { minutes: 0, seconds: 0 };

    const minutes = Math.floor(timeDiff / (1000 * 60)); // Calculate remaining minutes
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000); // Calculate remaining seconds

    return { minutes, seconds };
  }

  const genOrderedList = () => {
    return (
      <Card
        bordered
        style={{
          width: "100%",
          borderRadius: 10,
          boxShadow: "0px 4px 8px 0px #00000040",
        }}
      >
        <Row>
          <Col span={24}>
            {resultBasketOrder?.map((item, index) => {
              return (
                <Row>
                  <Col
                    span={6}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center"
                    }}
                  >
                    <img
                      src={`${serverUrl}/${item?.imgCoverUrl}`}
                      width={142}
                      height={102}
                      style={{
                        width: "100%",
                        top: 0,
                        left: 0,
                        borderRadius: 8,
                        marginRight: 12
                      }}
                      alt={"Witte-bangkok Payment"}
                    />
                  </Col>

                  <Col
                    xs={18}
                    xl={18}
                    style={{ paddingLeft: width < 1200 ? 0 : 24 }}
                  >
                    <Row>
                      <Col span={24}>
                        <label
                          className="payment-order-title"
                          style={{ fontWeight: 600, fontSize: 20 }}
                        >
                          {item?.title}
                        </label>
                      </Col>

                      <Col span={24}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingTop: 6
                          }}
                        >
                          <label style={{ fontSize: 20 }}>
                            ราคา{" "}{Intl.NumberFormat("en", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(item?.price)}{" "}บาท
                          </label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  {resultBasketOrder?.length !== index + 1 ? (
                    <Col span={24}>
                      <Divider style={{ marginTop: 11, marginBottom: 15 }} />
                    </Col>
                  ) : (
                    []
                  )}
                </Row>
              );
            })}
          </Col>
        </Row>
      </Card>
    );
  };

  const getPaymentAccount = async () => {
    const result = await getPaymentAccountFetch();
    setPaymentAccount(result);
  };

  const getBaseApi = async () => {
    setLoading(true);

    const isLogin = await detectSignIn();
    if (isLogin) {
      let uid = firebase.auth().currentUser.uid;

      getDay();
      getMonth();
      getYear();
      setUid(uid);

      getPaymentAccount();

      await detectCourseHasBeenPurchased(uid);

      await getCourseById();
    } else {
      navigate("/login");
    }

    setLoading(false);
  };

  useEffect(() => {
    getBaseApi();
  }, []);

  return (
    <>
      <Header firebase={props.firebase} user={props.user} />

      <article>
        <Content style={{ backgroundColor: "#FFFFFF" }}>
          <article>
            {!loading ? (
              <div style={{ marginInline: "auto", maxWidth: 1200, marginTop: 37 }}>
                <Row style={{ maxWidth: 724 }}>
                  <Row style={{ width: "100%" }}>
                    <Col
                      span={24}
                      style={{ paddingLeft: 15, paddingRight: 15 }}
                    >
                      <Steps
                        current={currentStep}
                        labelPlacement="vertical"
                        items={[
                          {
                            title: "เลือกวิธีการชำระเงิน",
                          },
                          {
                            title: "ชำระเงิน เเละส่งหลักฐาน",
                          },
                          {
                            title: "รับหลักฐานชำระเงิน",
                          },
                        ]}
                      />
                    </Col>
                  </Row>

                  {currentStep === 0 && (
                    <>
                      <Col
                        span={24}
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                          marginTop: 37
                        }}
                      >
                        {genOrderedList()}
                      </Col>
                      <Col
                        span={24}
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                        }}
                      >
                        {
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 24,
                              textAlign: "center",
                              marginTop: 37,
                            }}
                          >
                            ช่องทางชำระเงิน (คลิก
                            <img
                              src="/assets/images/page/payment/arrow-down.png"
                              width={42}
                              height={42}
                              alt={"Witte-bangkok Payment"}
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                            )
                          </div>
                        }
                      </Col>
                      <Row
                        style={{
                          marginInline: "auto",
                          marginTop: 24,
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <Col
                          span={24}
                          style={{ paddingLeft: 15, paddingRight: 15 }}
                        >
                          <Card
                            bordered
                            style={{
                              borderRadius: 10,
                              boxShadow: "0px 4px 8px 0px #00000040",
                              cursor: "pointer",
                              maxWidth: 491,
                              marginInline: "auto",
                            }}
                            onClick={() => {
                              setCurrentStep(1);
                            }}
                          >
                            <Row>
                              <Col
                                span={6}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  justifyContent: "center"
                                }}
                              >
                                <img
                                  src="/assets/images/payment/kbank.png"
                                  width={48}
                                  height={48}
                                  style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                    objectFit: "cover",
                                    marginRight: 12
                                  }}
                                  alt={"Witte-bangkok Bank"}
                                />
                              </Col>

                              <Col
                                span={18}
                                style={{
                                  paddingLeft: width < 1200 ? 0 : 24,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <label
                                  className="payment-order-title"
                                  style={{
                                    fontWeight: 400,
                                  }}
                                >
                                  ชำระเงินด้วยโอนเงิน (กสิกรไทย)
                                </label>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    </>
                  )}
                  {currentStep === 1 && (
                    <>
                      <Col
                        span={24}
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                        }}
                      >
                        <p
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 32,
                            textAlign: "center",
                            fontWeight: 500,
                            marginTop: 24,
                          }}
                        >
                          จำนวนเงินที่ต้องชำระ&nbsp;
                          <span style={{ color: "red" }}>
                            {Intl.NumberFormat("en", {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            }).format(resultBasketOrder?.[0]?.price ?? 0)}
                          </span>
                          &nbsp;บาท
                        </p>
                      </Col>

                      {/**Payment form */}
                      <Col span={24} style={{ marginTop: 24 }}>
                        <Row gutter={[12, 12]}>
                          <Col span={6}>
                            <label style={{ float: "right" }}>ธนาคาร</label>
                          </Col>
                          <Col span={18}>
                            <label>
                              {paymentAccount?.bank_category?.bankName ??
                                "ธนาคารกสิกรไทย"}
                            </label>
                          </Col>

                          <Col span={6}>
                            <label style={{ float: "right" }}>ชื่อบัญชี</label>
                          </Col>
                          <Col span={18}>
                            <label>
                              {paymentAccount?.accountName ?? "DR.DUANG"}
                            </label>
                          </Col>

                          <Col span={6}>
                            <label style={{ float: "right" }}>
                              เลขที่บัญชี
                            </label>
                          </Col>
                          <Col span={18}>
                            <label>
                              {paymentAccount?.accountNumber ?? "732-2-26013-6"}
                            </label>
                          </Col>

                          <Col span={6}>
                            <label style={{ float: "right" }}>ส่งหลักฐาน</label>
                          </Col>
                          <Col span={18}>
                            <Row gutter={[12, 0]}>
                              <Col span={24}>
                                <label>
                                  วันเเละเวลาที่โอน (ดูในสลิปธนาคาร)
                                </label>
                              </Col>

                              <Col xs={24} sm={12} md={8} lg={5}>
                                <Form
                                  form={form}
                                  layout="vertical"
                                  onFinish={onFinish}
                                >
                                  <Form.Item
                                    name="day"
                                    label="วัน"
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกวัน",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      style={{ width: "100%" }}
                                      placeholder="วัน"
                                      optionFilterProp="children"
                                      allowClear
                                    >
                                      {day.map((val, index) => (
                                        <Option key={index} value={val.value}>
                                          {val.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Form>
                              </Col>

                              <Col xs={24} sm={12} md={8} lg={7}>
                                <Form
                                  form={form}
                                  layout="vertical"
                                  onFinish={onFinish}
                                >
                                  <Form.Item
                                    name="month"
                                    label="เดือน"
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกเดือน",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      style={{ width: "100%" }}
                                      placeholder="เดือน"
                                      optionFilterProp="children"
                                      allowClear
                                    >
                                      {month.map((val, index) => (
                                        <Option key={index} value={val.value}>
                                          {val.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Form>
                              </Col>

                              <Col xs={24} sm={12} md={8} lg={6}>
                                <Form
                                  form={form}
                                  layout="vertical"
                                  onFinish={onFinish}
                                >
                                  <Form.Item
                                    name="year"
                                    label="ปี"
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกปี",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      style={{ width: "100%" }}
                                      placeholder="ปี"
                                      optionFilterProp="children"
                                      allowClear
                                    >
                                      {year.map((val, index) => (
                                        <Option key={index} value={val.value}>
                                          {val.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Form>
                              </Col>

                              <Col xs={24} sm={12} md={8} lg={6}>
                                <Form
                                  form={form}
                                  layout="vertical"
                                  onFinish={onFinish}
                                >
                                  <Form.Item
                                    name="time"
                                    label="เวลา"
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "กรุณาเลือกเวลา",
                                      },
                                    ]}
                                  >
                                    <TimePicker
                                      showNow={false}
                                      placeholder="เวลา"
                                      style={{ width: "100%" }}
                                      locale={{
                                        ...locale,
                                        lang: {
                                          ...locale.lang,
                                          // now: "เวลาปัจจุบัน",
                                          ok: "ตกลง",
                                        },
                                      }}
                                      format={"HH:mm"}
                                    />
                                  </Form.Item>
                                </Form>
                              </Col>

                              <Col span={24} style={{ paddingBottom: 6 }}>
                                <Form
                                  form={form}
                                  layout="vertical"
                                  onFinish={onFinish}
                                >
                                  <Form.Item
                                    name="imgTransferSlipURL"
                                    label={
                                      <>
                                        <label
                                          style={{
                                            color: "red",
                                            margin: 0,
                                            padding: 0,
                                          }}
                                        >
                                          *
                                        </label>
                                        <label
                                          style={{
                                            margin: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 5,
                                          }}
                                        >
                                          หลักฐานการโอน (สลิป)
                                        </label>
                                      </>
                                    }
                                  >
                                    <div style={{ paddingBottom: 12 }}>
                                      {imgTransferSlipURL.imageUrl ? (
                                        <Image
                                          style={{
                                            width: 250,
                                            border: "1px solid #e8e8e8",
                                            borderRadius: 8,
                                          }}
                                          alt="avatar"
                                          src={`${serverUrl}/${imgTransferSlipURL.imageUrl}`}
                                        />
                                      ) : (
                                        <div
                                          style={{
                                            width: 330,
                                            height: 180,
                                            backgroundColor: "#D9D9D9",
                                            borderRadius: 8,
                                            display: "grid",
                                            placeItems: "center",
                                          }}
                                        >
                                          <Image
                                            width={142}
                                            height={157}
                                            style={{
                                              maxWidth: "100%",
                                              objectFit: "cover",
                                              border: "1px solid #e8e8e8",
                                            }}
                                            src="error"
                                            fallback={`./assets/images/payment/slip-df.png`}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <Upload
                                      {...optionTransferSlipImage}
                                      listType="picture"
                                      accept="image/jpeg, image/png, image/jfif"
                                      maxCount={1}
                                      showUploadList={false}
                                    >
                                      <Button
                                        type="primary"
                                        disabled={props.isDisabled}
                                        style={{ width: 245 }}
                                        icon={
                                          imgTransferSlipURL.loading ? (
                                            <LoadingOutlined />
                                          ) : (
                                            <UploadOutlined />
                                          )
                                        }
                                      >
                                        อัพโหลด
                                      </Button>
                                    </Upload>
                                  </Form.Item>
                                </Form>
                              </Col>
                            </Row>
                          </Col>

                          {width >= 590 ? (
                            <Col xs={24} sm={24} md={6} lg={6}></Col>
                          ) : (
                            []
                          )}
                          <Col xs={24} sm={24} md={18} lg={18}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Icon
                                icon="carbon:information"
                                style={{
                                  color: "#F3BB02",
                                  width: 20,
                                  height: 20,
                                }}
                              />
                              <label style={{ paddingLeft: 5 }}>
                                กรุณาเก็บหลักฐานการโอนเงินไว้
                              </label>
                            </div>
                          </Col>

                          {width >= 590 ? (
                            <Col xs={24} sm={24} md={6} lg={6}></Col>
                          ) : (
                            []
                          )}
                          <Col xs={24} sm={24} md={18} lg={18}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Icon
                                icon="carbon:information"
                                style={{
                                  color: "#F3BB02",
                                  width: 20,
                                  height: 20,
                                }}
                              />
                              <label style={{ paddingLeft: 5 }}>
                                การตรวจสอบจะใช้เวลาไม่เกิน 24 ชม.
                                เราจะดำเนินการให้เร็วที่สุด
                              </label>
                            </div>
                          </Col>
                          {width >= 590 ? (
                            <Col xs={24} sm={24} md={6} lg={6}></Col>
                          ) : (
                            []
                          )}
                          <Col xs={24} sm={24} md={18} lg={18} style={{ paddingBottom: 48 }}>
                            <Button
                              type="primary"
                              loading={paymentmethodLoading}
                              onClick={() => {
                                form.submit();
                              }}
                            >
                              {!paymentmethodLoading ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Icon
                                    icon="bi:send"
                                    style={{ color: "white" }}
                                  />
                                  <label
                                    style={{
                                      paddingLeft: 10,
                                      cursor: "pointer",
                                    }}
                                  >
                                    ส่งหลักฐานการชำระเงิน
                                  </label>
                                </div>
                              ) : (
                                []
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </>
                  )}
                  {currentStep === 2 && (
                    <>
                      <Col
                        span={24}
                        style={{
                          paddingLeft: 15,
                          paddingRight: 15,
                          textAlign: "center",
                          marginTop: 37,
                        }}
                      >
                        <img
                          src="/assets/images/page/payment/success.png"
                          alt={"Witte-bangkok Payment success"}
                          height={199}
                          width={199}
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                        <div
                          style={{
                            fontSize: 32,
                            fontWeight: 500,
                            marginTop: 24,
                          }}
                        >
                          เราได้รับหลักฐานการชำระเงินเเล้ว
                        </div>
                        <div style={{ fontSize: 26 }}>
                          การตรวจสอบจะใช้เวลาไม่เกิน 24 ชม.
                          เราจะดำเนินการให้เร็วที่สุด
                        </div>
                        <Button
                          type="primary"
                          size="large"
                          onClick={() => {
                            navigate("/");
                          }}
                          style={{ marginTop: 24, fontSize: 16 }}
                        >
                          กลับไปหน้า
                        </Button>
                      </Col>
                    </>
                  )}
                </Row>

                <Modal
                  maskClosable={false}
                  title={
                    <label style={{ fontWeight: 100 }}>
                      {pamentTransferModal.title}
                    </label>
                  }
                  visible={pamentTransferModal.isShow}
                  width={550}
                  loading={paymentmethodLoading}
                  onCancel={() => {
                    // close modal
                    setFormDefault();
                  }}
                  footer={[
                    <Button
                      type="primary"
                      loading={paymentmethodLoading}
                      onClick={() => {
                        form.submit();
                      }}
                    >
                      {!paymentmethodLoading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon icon="bi:send" style={{ color: "white" }} />
                          <label style={{ paddingLeft: 10, cursor: "pointer" }}>
                            ส่งหลักฐานการชำระเงิน
                          </label>
                        </div>
                      ) : (
                        []
                      )}
                    </Button>,
                  ]}
                >
                  <Row gutter={[12, 12]}>
                    <Col span={6}>
                      <label style={{ float: "right" }}>ธนาคาร</label>
                    </Col>
                    <Col span={18}>
                      <label>
                        {paymentAccount?.bank_category?.bankName ?? "-"}
                      </label>
                    </Col>

                    <Col span={6}>
                      <label style={{ float: "right" }}>ชื่อบัญชี</label>
                    </Col>
                    <Col span={18}>
                      <label>{paymentAccount?.accountName ?? "-"}</label>
                    </Col>

                    <Col span={6}>
                      <label style={{ float: "right" }}>เลขที่บัญชี</label>
                    </Col>
                    <Col span={18}>
                      <label>{paymentAccount?.accountNumber ?? "-"}</label>
                    </Col>

                    <Col span={6}>
                      <label style={{ float: "right" }}>ส่งหลักฐาน</label>
                    </Col>
                    <Col span={18}>
                      <Row gutter={[12, 0]}>
                        <Col span={24}>
                          <label>วันเเละเวลาที่โอน (ดูในสลิปธนาคาร)</label>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={5}>
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                          >
                            <Form.Item
                              name="day"
                              label="วัน"
                              style={{ width: "100%" }}
                              rules={[
                                { required: true, message: "กรุณาเลือกวัน" },
                              ]}
                            >
                              <Select
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="วัน"
                                optionFilterProp="children"
                                allowClear
                              >
                                {day.map((val, index) => (
                                  <Option key={index} value={val.value}>
                                    {val.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={7}>
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                          >
                            <Form.Item
                              name="month"
                              label="เดือน"
                              style={{ width: "100%" }}
                              rules={[
                                { required: true, message: "กรุณาเลือกเดือน" },
                              ]}
                            >
                              <Select
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="เดือน"
                                optionFilterProp="children"
                                allowClear
                              >
                                {month.map((val, index) => (
                                  <Option key={index} value={val.value}>
                                    {val.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                          >
                            <Form.Item
                              name="year"
                              label="ปี"
                              style={{ width: "100%" }}
                              rules={[
                                { required: true, message: "กรุณาเลือกปี" },
                              ]}
                            >
                              <Select
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="ปี"
                                optionFilterProp="children"
                                allowClear
                              >
                                {year.map((val, index) => (
                                  <Option key={index} value={val.value}>
                                    {val.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={6}>
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                          >
                            <Form.Item
                              name="time"
                              label="เวลา"
                              style={{ width: "100%" }}
                              rules={[
                                { required: true, message: "กรุณาเลือกเวลา" },
                              ]}
                            >
                              <TimePicker
                                showNow={false}
                                placeholder="เวลา"
                                style={{ width: "100%" }}
                                locale={{
                                  ...locale,
                                  lang: {
                                    ...locale.lang,
                                    // now: "เวลาปัจจุบัน",
                                    ok: "ตกลง",
                                  },
                                }}
                                format={"HH:mm"}
                              />
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col span={24} style={{ paddingBottom: 6 }}>
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                          >
                            <Form.Item
                              name="imgTransferSlipURL"
                              label={
                                <>
                                  <label
                                    style={{
                                      color: "red",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                  >
                                    *
                                  </label>
                                  <label
                                    style={{
                                      margin: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 5,
                                    }}
                                  >
                                    หลักฐานการโอน (สลิป)
                                  </label>
                                </>
                              }
                            >
                              <div style={{ paddingBottom: 12 }}>
                                {imgTransferSlipURL.imageUrl ? (
                                  <Image
                                    style={{
                                      width: 250,
                                      border: "1px solid #e8e8e8",
                                      borderRadius: 8,
                                    }}
                                    alt="avatar"
                                    src={`${serverUrl}/${imgTransferSlipURL.imageUrl}`}
                                    preview={{
                                      src: `${serverUrl}/${imgTransferSlipURL.imageUrl}`,
                                    }}
                                  />
                                ) : (
                                  <Image
                                    style={{
                                      width: 250,
                                      border: "1px solid #e8e8e8",
                                    }}
                                    src="error"
                                    fallback={`${imgDefaultUrl}`}
                                  />
                                )}
                              </div>

                              <Upload
                                {...optionTransferSlipImage}
                                listType="picture"
                                accept="image/jpeg, image/png, image/jfif"
                                maxCount={1}
                                showUploadList={false}
                              >
                                <Button
                                  type="primary"
                                  disabled={props.isDisabled}
                                  style={{ width: 245 }}
                                  icon={
                                    imgTransferSlipURL.loading ? (
                                      <LoadingOutlined />
                                    ) : (
                                      <UploadOutlined />
                                    )
                                  }
                                >
                                  อัพโหลด
                                </Button>
                              </Upload>
                            </Form.Item>
                          </Form>
                        </Col>
                      </Row>
                    </Col>

                    {width >= 590 ? (
                      <Col xs={24} sm={24} md={4} lg={4}></Col>
                    ) : (
                      []
                    )}
                    <Col xs={24} sm={24} md={20} lg={20}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Icon
                          icon="carbon:information"
                          style={{ color: "#FF7F00", width: 20, height: 20 }}
                        />
                        <label style={{ paddingLeft: 5 }}>
                          กรุณาเก็บหลักฐานการโอนเงินไว้
                        </label>
                      </div>
                    </Col>

                    {width >= 590 ? (
                      <Col xs={24} sm={24} md={4} lg={4}></Col>
                    ) : (
                      []
                    )}
                    <Col xs={24} sm={24} md={20} lg={20}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Icon
                          icon="carbon:information"
                          style={{ color: "#FF7F00", width: 20, height: 20 }}
                        />
                        <label style={{ paddingLeft: 5 }}>
                          การตรวจสอบจะใช้เวลาไม่เกิน 24 ชม.
                          เราจะดำเนินการให้เร็วที่สุด
                        </label>
                      </div>
                    </Col>
                  </Row>
                </Modal>
              </div>
            ) : (
              <LoadingPage loading={loading} />
            )}
          </article>
        </Content>
      </article>

      <Footer />
    </>
  );
}
